import { Button, Input, Select } from "antd";
import * as React from "react";
import { Formik } from "formik";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getDepartments } from "../../Graphs/Department/GetDepartment";

const extractDeptIds = (deptData) => {
  if (!deptData) return [];
  const getSingleId = (item) => {
    if (!item) return null;
    if (typeof item === "string") return item;
    if (typeof item === "object") {
      if (item._id) return typeof item._id === "object" ? item._id.toString() : String(item._id);
      if (item.id) return String(item.id);
    }
    return String(item);
  };

  if (Array.isArray(deptData)) {
    return deptData.map(getSingleId).filter(Boolean);
  }
  const single = getSingleId(deptData);
  return single ? [single] : [];
};

export class EditForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    const initialDepartments = extractDeptIds(
      this.props.data ? this.props.data.department_id : null
    );

    this.state = {
      data: [],
      departments: [],
      selectedDepartment: initialDepartments,
      errors: {},
    };
  }

  async componentDidMount() {
    const { Token } = this.props;

    try {
      let DepartmentData = await getDepartments(Token);

      if (DepartmentData && DepartmentData.data && DepartmentData.data.length >= 1) {
        this.setState({
          departments: DepartmentData.data.map((dept) => ({
            value: String(dept._id),
            label: dept.name,
          })),
        });
      }
    } catch (err) {
      console.error("Error fetching departments:", err);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      const updatedDepartments = extractDeptIds(
        this.props.data ? this.props.data.department_id : null
      );
      this.setState({ selectedDepartment: updatedDepartments });
    }
  }

  validateForm = (values) => {
    const errors = {};
    const { loginData } = this.props;
    const { selectedDepartment } = this.state;

    if (!values.first_name || !values.first_name.trim()) {
      errors.first_name = "First name is required";
    }

    if (!values.last_name || !values.last_name.trim()) {
      errors.last_name = "Last name is required";
    }

    if (
      loginData &&
      (loginData.role === "corporate" || loginData.role === "corporate_admin")
    ) {
      if (
        !selectedDepartment ||
        (Array.isArray(selectedDepartment) && selectedDepartment.length === 0)
      ) {
        errors.selectedDepartment = "Department is required";
      }
    }

    return errors;
  };

  handleSubmit = async (values) => {
    const { selectedDepartment } = this.state;
    values.department_id = selectedDepartment;
    delete values.selectedDepartment;
    this.props.onSubmit(values, this.props.data._id);
  };

  render() {
    const { data, loginData } = this.props;

    return (
      <div style={{ padding: "4px 0" }}>
        <Formik
          initialValues={{
            first_name: data ? data.first_name || "" : "",
            last_name: data ? data.last_name || "" : "",
            phone: data ? data.phone || "" : "",
            country: data ? data.country || "" : "",
            city: data ? data.city || "" : "",
            bio: data ? data.bio || "" : "",
            current_location: data ? data.current_location || "" : "",
            address_line1: data ? data.address_line1 || "" : "",
            address_line2: data ? data.address_line2 || "" : "",
            job_post: data ? data.job_post || "" : "",
          }}
          validate={this.validateForm}
          onSubmit={this.handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => {
            return (
              <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {/* First Name & Last Name Row */}
                <div style={{ display: "flex", gap: "16px", width: "100%" }}>
                  <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                    <label
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#334155",
                        marginBottom: "6px",
                      }}
                    >
                      First Name <span style={{ color: "#ef4444" }}>*</span>
                    </label>
                    <Input
                      id="first_name"
                      placeholder="First Name"
                      value={values.first_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{
                        height: "42px",
                        borderRadius: "8px",
                        borderColor:
                          errors.first_name && touched.first_name
                            ? "#ef4444"
                            : "#cbd5e1",
                        fontSize: "14px",
                        color: "#0f172a",
                        padding: "0 12px",
                      }}
                    />
                    {errors.first_name && touched.first_name ? (
                      <p
                        style={{
                          color: "#ef4444",
                          fontSize: "12px",
                          margin: "4px 0 0 0",
                        }}
                      >
                        {errors.first_name}
                      </p>
                    ) : null}
                  </div>

                  <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                    <label
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#334155",
                        marginBottom: "6px",
                      }}
                    >
                      Last Name <span style={{ color: "#ef4444" }}>*</span>
                    </label>
                    <Input
                      id="last_name"
                      placeholder="Last Name"
                      value={values.last_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      style={{
                        height: "42px",
                        borderRadius: "8px",
                        borderColor:
                          errors.last_name && touched.last_name
                            ? "#ef4444"
                            : "#cbd5e1",
                        fontSize: "14px",
                        color: "#0f172a",
                        padding: "0 12px",
                      }}
                    />
                    {errors.last_name && touched.last_name ? (
                      <p
                        style={{
                          color: "#ef4444",
                          fontSize: "12px",
                          margin: "4px 0 0 0",
                        }}
                      >
                        {errors.last_name}
                      </p>
                    ) : null}
                  </div>
                </div>

                {/* Email & Department Row */}
                <div style={{ display: "flex", gap: "16px", width: "100%" }}>
                  {data && data.email ? (
                    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                      <label
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#334155",
                          marginBottom: "6px",
                        }}
                      >
                        Email
                      </label>
                      <Input
                        id="email"
                        value={data.email}
                        disabled
                        style={{
                          height: "42px",
                          borderRadius: "8px",
                          borderColor: "#e2e8f0",
                          backgroundColor: "#f8fafc",
                          color: "#64748b",
                          fontSize: "14px",
                          padding: "0 12px",
                        }}
                      />
                    </div>
                  ) : null}

                  {loginData &&
                    (loginData.role === "corporate" ||
                      loginData.role === "corporate_admin") ? (
                    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                      <label
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#334155",
                          marginBottom: "6px",
                        }}
                      >
                        Department <span style={{ color: "#ef4444" }}>*</span>
                      </label>
                      <div style={{ display: "flex", gap: "8px", width: "100%" }}>
                        <select
                          id="edit_single_dept_select"
                          className="form-control"
                          value={this.state.tempSelectedDept || ""}
                          onChange={(e) => this.setState({ tempSelectedDept: e.target.value })}
                          style={{
                            flex: 1,
                            height: "42px",
                            borderRadius: "8px",
                            border: "1px solid #cbd5e1",
                            padding: "0 36px 0 12px",
                            fontSize: "14px",
                            color: "#0f172a",
                            backgroundColor: "#ffffff",
                            cursor: "pointer",
                            outline: "none",
                            appearance: "none",
                            WebkitAppearance: "none",
                            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2364748b'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "right 12px center",
                            backgroundSize: "16px 16px",
                          }}
                        >
                          <option value="">Select Department</option>
                          {this.state.departments &&
                            this.state.departments
                              .filter((dept) => {
                                const deptId = String(dept.value || dept._id);
                                const selected = (this.state.selectedDepartment || []).map(String);
                                return !selected.includes(deptId);
                              })
                              .map((dept) => (
                                <option
                                  key={dept.value || dept._id}
                                  value={dept.value || dept._id}
                                >
                                  {dept.label || dept.name}
                                </option>
                              ))}
                        </select>
                        <button
                          type="button"
                          onClick={() => {
                            if (this.state.tempSelectedDept) {
                              const current = (this.state.selectedDepartment || []).map(String);
                              if (!current.includes(this.state.tempSelectedDept)) {
                                this.setState({
                                  selectedDepartment: [...current, this.state.tempSelectedDept],
                                  tempSelectedDept: ""
                                });
                              } else {
                                this.setState({ tempSelectedDept: "" });
                              }
                            }
                          }}
                          style={{
                            height: "42px",
                            padding: "0 18px",
                            backgroundColor: "#4466f2",
                            color: "#ffffff",
                            border: "none",
                            borderRadius: "8px",
                            fontWeight: "600",
                            cursor: "pointer",
                            whiteSpace: "nowrap"
                          }}
                        >
                          Add
                        </button>
                      </div>

                      {/* Selected Departments List Box */}
                      {Array.isArray(this.state.selectedDepartment) &&
                        this.state.selectedDepartment.length > 0 && (
                          <div
                            style={{
                              marginTop: "10px",
                              padding: "8px 12px",
                              backgroundColor: "#f8fafc",
                              border: "1px solid #e2e8f0",
                              borderRadius: "8px",
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "6px",
                              minHeight: "42px",
                              alignItems: "center"
                            }}
                          >
                            {this.state.selectedDepartment.map((dId) => {
                              const deptObj = (this.state.departments || []).find(
                                (d) => String(d.value || d._id) === String(dId)
                              );
                              const label = deptObj ? (deptObj.label || deptObj.name) : dId;

                              return (
                                <span
                                  key={dId}
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    backgroundColor: "#e0e7ff",
                                    color: "#3730a3",
                                    padding: "4px 10px",
                                    borderRadius: "16px",
                                    fontSize: "12px",
                                    fontWeight: "500"
                                  }}
                                >
                                  {label}
                                  <span
                                    onClick={() => {
                                      const updated = this.state.selectedDepartment.filter(
                                        (id) => String(id) !== String(dId)
                                      );
                                      this.setState({ selectedDepartment: updated });
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                      color: "#4338ca",
                                      lineHeight: 1
                                    }}
                                  >
                                    &times;
                                  </span>
                                </span>
                              );
                            })}
                          </div>
                        )}

                      {errors.selectedDepartment ? (
                        <p
                          style={{
                            color: "#ef4444",
                            fontSize: "12px",
                            margin: "4px 0 0 0",
                          }}
                        >
                          {errors.selectedDepartment}
                        </p>
                      ) : null}
                    </div>
                  ) : null}
                </div>

                {/* Footer Action Buttons */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "12px",
                    marginTop: "28px",
                    paddingTop: "16px",
                    borderTop: "1px solid #e2e8f0",
                  }}
                >
                  <Button
                    onClick={this.props.handleCancel}
                    style={{
                      height: "40px",
                      padding: "0 22px",
                      borderRadius: "8px",
                      borderColor: "#cbd5e1",
                      color: "#475569",
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    onClick={handleSubmit}
                    style={{
                      height: "40px",
                      padding: "0 24px",
                      borderRadius: "8px",
                      background: "#5C6AC4",
                      borderColor: "#5C6AC4",
                      color: "#ffffff",
                      fontWeight: "600",
                      fontSize: "14px",
                      boxShadow: "0 2px 4px rgba(92, 106, 196, 0.25)",
                    }}
                  >
                    Save Changes
                  </Button>
                </div>
              </div>
            );
          }}
        </Formik>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginData: state.auth.loginUserData,
});

export default connect(mapStateToProps)(withRouter(EditForm));

